import axiosInstance from "../../apiAxios/axiosInstance";

// Category List
export const ChildCategoryList = async(payload) => {
  const response= await axiosInstance.post("/admin/child-category-list",payload);
   return response.data;
};
export const ActiveChildCategoryList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-child-category-list",payload);
   return resposne.data
};
// Create
export const AddChildCategory = async(payload) => {
const response= await axiosInstance.post("/admin/child-category-store", payload);
    return response.data;
};

// Show
export const VirwChildCategory =async (payload) => {
const response=await  axiosInstance.post("/admin/child-category-show", payload);
    return response.data;
};

// Update
export const UpdateChildCategory = async(payload) => {
  const response= await axiosInstance.post("/admin/child-category-update", payload);
    return response.data;
};

// Delete
export const DeleteChildCategory = async(payload) => {
  const response= await axiosInstance.post("/admin/child-category-delete", payload);
    return response.data;
};

// Status Change
export const ChildCategoryChangeStatus = async(payload) => {
  const response=await axiosInstance.post("/admin/child-category-status-update", payload);
    return response.data;
};